var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8424 10.3128C14.2911 11.0627 13.7279 12 12.8319 12H1.16799C0.270212 12 -0.290323 11.0612 0.157434 10.3128L5.98945 0.562149C6.4383 -0.188062 7.56251 -0.186703 8.01056 0.562149L13.8424 10.3128ZM7 8.29688C6.38252 8.29688 5.88195 8.77957 5.88195 9.375C5.88195 9.97043 6.38252 10.4531 7 10.4531C7.61749 10.4531 8.11806 9.97043 8.11806 9.375C8.11806 8.77957 7.61749 8.29688 7 8.29688ZM5.93851 4.42158L6.11881 7.60908C6.12724 7.75823 6.25514 7.875 6.41004 7.875H7.58997C7.74487 7.875 7.87277 7.75823 7.8812 7.60908L8.0615 4.42158C8.07062 4.26047 7.93759 4.125 7.77027 4.125H6.22971C6.06239 4.125 5.92939 4.26047 5.93851 4.42158Z",
    fill: "url(#paint0_linear_2886_3991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2886_3991",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8301E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E77264"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.9dc919cbfdd7cce8159ccb2c9e62a855.svg";
export { ForwardRef as ReactComponent };